export class KeyValueModel{
    Key: string;
    Value: string;
    
    constructor(key?: string, value?: string) {
        this.Key = key;
        this.Value = value;
    }
}